import { url, header } from "../../apis/Index";
import { toast } from "react-toastify";
import axios from "axios";

export const getBenMarks = () => {
  return (dispatch) => {
    dispatch({
      type: "GETTING_PERFORMANCE_INFO",
      fetchingMarksLoaders: true,
    });
    axios
      .get(`${url}/beneficiary-performances`, {
        headers: header,
      })
      .then((benMarks) => {
        dispatch({
          type: "GET_BENMARKS",
          benMarks,
        });
        dispatch({
          type: "GETTING_PERFORMANCE_INFO",
          fetchingMarksLoaders: false,
        });
      })
      .catch((error) => {
        dispatch({
          type: "GETTING_PERFORMANCE_INFO",
          fetchingMarksLoaders: false,
        });
        dispatch({
          type: "GET_PERFORMANCE_FAILED",
          fetchingMarksErroredMessage: error.message,
        });
      });
  };
};

export const addBenMark = (benMark, closeFormAfterAdding) => {
  return (dispatch) => {
    dispatch({
      type: "SENDING_PERFORMANCE_INFO",
      loader: true,
    });

    axios
      .post(`${url}/beneficiary-performances`, benMark, {
        headers: header,
      })
      .then((mark) => {
        console.log(mark);
        dispatch({
          type: "CREATE_BENMARK",
          mark,
        });

        dispatch({
          type: "SENDING_PERFORMANCE_INFO",
          loader: false,
        });
        closeFormAfterAdding();
        toast.success("Marks added", {
          position: toast.POSITION.TOP_RIGHT,
        });
      })
      .catch((error) => {
        console.log(error);
        dispatch({
          type: "SENDING_PERFORMANCE_INFO",
          loader: false,
        });
        dispatch({
          type: "REGISTER_PERFORMANCE_FAILED",
          registerMarksActionFailedMessage: "Recording marks failed",
        });
      });
  };
};

export const updateBenMark = (updatedMark, id, closeFormAfterAdding) => {
  return (dispatch) => {
    dispatch({
      type: "SENDING_PERFORMANCE_INFO",
      loader: true,
    });
    axios
      .put(`${url}/beneficiary-performances/${id}`, updatedMark, {
        headers: header,
      })
      .then((mark) => {
        dispatch({
          type: "UPDATE_BENMARK",
          mark,
        });
        dispatch({
          type: "SENDING_PERFORMANCE_INFO",
          loader: false,
        });
        closeFormAfterAdding();
      })
      .catch((error) => {
        console.log(error);
        dispatch({
          type: "REGISTER_PERFORMANCE_FAILED",
          registerMarksActionFailedMessage: "Updating failed",
        });
      });
  };
};

export const deleteBenMark = (id) => {
  return (dispatch) => {
    dispatch({
      type: "DELETING_PERFORMANCE_INFO",
      deletingMarks: {
        id: id,
        deleting: true,
      },
    });
    axios
      .delete(`${url}/beneficiary-performances/${id}`, {
        headers: header,
      })
      .then(() => {
        dispatch({
          type: "DELETE_BENMARK",
          id,
        });
        dispatch({
          type: "DELETING_PERFORMANCE_INFO",
          deletingMarks: {
            id: null,
            deleting: false,
          },
        });
      })
      .catch((error) => {
        toast.error("Failed to delete  marks", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 5000,
        });
        dispatch({
          type: "DELETING_PERFORMANCE_INFO",
          deletingMarks: {
            id: id,
            deleting: false,
          },
        });
      });
  };
};
